import SvgIcon from "@material-ui/core/SvgIcon";
import React from "react";

function Icon(props) {
  return (
    <SvgIcon
      className="collaborate-card-image"
      {...props}
      viewBox="0 0 512 512"
      fontSize="large"
      style={{ width: "80%", fontSize: "120px" }}
    >
      <g>
        <g>
          <path
            d="M502,409.995c5.523,0,10-4.477,10-10V50.007c0-27.57-22.43-50-50-50H50c-27.57,0-50,22.43-50,50v372.004
                        c0,27.57,22.43,50,50,50h360.482l27.262,27.262c8.48,8.48,19.62,12.72,30.759,12.72c11.139,0,22.279-4.24,30.759-12.72
                        c16.96-16.961,16.96-44.558,0-61.519l-98.632-98.632c-1.875-1.875-4.419-2.929-7.071-2.929c-2.652,0-5.196,1.054-7.071,2.929
                        l-16.615,16.615l-10.275-10.275C381.019,320.783,394,288.591,394,253.423c0-30.572-9.646-59.643-27.896-84.068
                        c-17.638-23.607-42.768-41.419-70.761-50.154c-5.271-1.645-10.88,1.295-12.525,6.567c-1.646,5.272,1.295,10.88,6.567,12.525
                        C339.996,154.086,374,200.354,374,253.423c0,66.49-54.094,120.583-120.583,120.583s-120.583-54.094-120.583-120.583
                        c0-52.608,33.623-98.755,83.665-114.83c5.258-1.689,8.152-7.321,6.463-12.58c-1.689-5.259-7.323-8.149-12.579-6.462
                        c-28.122,9.034-52.325,26.413-69.992,50.26c-18.028,24.332-27.557,53.245-27.557,83.612c0,77.518,63.065,140.583,140.583,140.583
                        c35.168,0,67.36-12.981,92.039-34.402l10.275,10.275l-16.619,16.619c-3.905,3.905-3.905,10.237,0,14.143l51.37,51.37H50
                        c-16.542,0-30-13.458-30-30V91.956c0.33,0.033,0.665,0.051,1.004,0.051H492v307.988C492,405.518,496.477,409.995,502,409.995z
                        M388.203,421.447l16.619-16.619c3.905-3.905,3.905-10.237,0-14.143c-3.905-3.905-10.237-3.905-14.143,0l-16.619,16.619
                        l-13.735-13.735l16.614-16.613c0.002-0.002,0.003-0.003,0.005-0.005s0.003-0.003,0.005-0.005l16.611-16.611l91.561,91.562
                        c9.163,9.163,9.163,24.071,0,33.233c-9.162,9.163-24.072,9.163-33.234,0L388.203,421.447z M21.004,72.007
                        c-0.339,0-0.674,0.018-1.004,0.051V50.007c0-16.542,13.458-30,30-30h412c16.542,0,30,13.458,30,30v22H21.004z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M448,36.007H222.065c-5.523,0-10,4.477-10,10c0,5.523,4.477,10,10,10H448c5.523,0,10-4.477,10-10
                        C458,40.484,453.523,36.007,448,36.007z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M111.07,38.937c-1.86-1.86-4.44-2.93-7.07-2.93s-5.21,1.07-7.07,2.93S94,43.377,94,46.007s1.07,5.21,2.93,7.07
                        c1.86,1.86,4.44,2.93,7.07,2.93s5.21-1.07,7.07-2.93c1.86-1.86,2.93-4.44,2.93-7.07S112.93,40.797,111.07,38.937z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M71.07,38.937c-1.86-1.86-4.44-2.93-7.07-2.93s-5.21,1.07-7.07,2.93S54,43.377,54,46.007s1.07,5.21,2.93,7.07
                        c1.86,1.86,4.44,2.93,7.07,2.93s5.21-1.07,7.07-2.93c1.86-1.86,2.93-4.44,2.93-7.07S72.93,40.797,71.07,38.937z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M151.07,38.937c-1.86-1.86-4.44-2.93-7.07-2.93s-5.21,1.07-7.07,2.93s-2.93,4.44-2.93,7.07s1.07,5.21,2.93,7.07
                        c1.86,1.86,4.44,2.93,7.07,2.93s5.21-1.07,7.07-2.93c1.86-1.86,2.93-4.44,2.93-7.07S152.93,40.797,151.07,38.937z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M253.794,112.84h-0.377c-5.523,0-10,4.477-10,10c0,5.523,4.477,10,10,10h0.289c0.015,0,0.03,0,0.045,0
                        c5.502,0,9.975-4.448,9.999-9.956C263.774,117.362,259.317,112.864,253.794,112.84z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M132.333,394.007H64c-5.523,0-10,4.477-10,10c0,5.523,4.477,10,10,10h68.333c5.523,0,10-4.477,10-10
                        S137.856,394.007,132.333,394.007z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M108.069,354.007H64c-5.523,0-10,4.477-10,10s4.477,10,10,10h44.069c5.523,0,10-4.477,10-10
                        S113.592,354.007,108.069,354.007z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M177.41,396.937c-1.87-1.86-4.44-2.93-7.08-2.93c-2.63,0-5.21,1.07-7.07,2.93s-2.93,4.44-2.93,7.07s1.07,5.21,2.93,7.07
                        c1.86,1.86,4.44,2.93,7.07,2.93c2.64,0,5.21-1.07,7.08-2.93c1.86-1.86,2.92-4.44,2.92-7.07S179.27,398.797,177.41,396.937z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M448,118.007h-78.127c-5.523,0-10,4.477-10,10c0,5.523,4.477,10,10,10H448c5.523,0,10-4.477,10-10
                        C458,122.484,453.523,118.007,448,118.007z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M448,158.007h-38.75c-5.523,0-10,4.477-10,10c0,5.523,4.477,10,10,10H448c5.523,0,10-4.477,10-10
                        C458,162.484,453.523,158.007,448,158.007z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M329.383,278.001c5.523,0,10-4.477,10-10s-4.477-10-10-10h-15.154c-0.151-2.816-0.504-5.579-1.035-8.279l15.308-15.407
                        c3.893-3.918,3.872-10.25-0.045-14.142c-3.918-3.893-10.25-3.872-14.142,0.045l-9.201,9.261
                        c-5.574-8.804-13.387-16.05-22.64-20.931v-7.012c-0.003-15.128-12.312-27.437-27.442-27.437h-2.892
                        c-15.13,0-27.439,12.309-27.439,27.439v7.012c-9.326,4.92-17.191,12.24-22.773,21.139l-9.408-9.469
                        c-3.893-3.918-10.225-3.938-14.142-0.045s-3.938,10.224-0.045,14.142l15.596,15.697c-0.495,2.586-0.83,5.228-0.978,7.92h-15.499
                        c-5.523,0-10,4.477-10,10s4.477,10,10,10h15.489c0.142,2.72,0.48,5.387,0.978,7.999l-15.585,15.687
                        c-3.893,3.918-3.872,10.25,0.045,14.142c1.951,1.938,4.5,2.906,7.048,2.906c2.57,0,5.14-0.985,7.094-2.952l9.382-9.443
                        c10.529,16.814,29.209,28.027,50.469,28.027h2.432c21.171,0,39.783-11.121,50.335-27.819l9.175,9.234
                        c1.955,1.967,4.524,2.952,7.094,2.952c2.548,0,5.098-0.968,7.048-2.906c3.917-3.893,3.938-10.224,0.045-14.142l-15.297-15.397
                        c0.524-2.682,0.875-5.424,1.025-8.221H329.383z M244.702,201.538c0-4.102,3.337-7.439,7.439-7.439h2.892
                        c4.102,0,7.439,3.337,7.439,7.439v0.165h-7.668h-2.432h-7.67V201.538z M294.317,274.786c0,21.788-17.726,39.514-39.515,39.514
                        h-2.432c-21.789,0-39.515-17.726-39.515-39.514v-13.568c0-21.789,17.726-39.515,39.515-39.515h2.432
                        c21.789,0,39.515,17.726,39.515,39.515V274.786z"
          />
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </SvgIcon>
  );
}

export default Icon;
